import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import * as moment from 'moment';
import { isArray } from 'rxjs/internal-compatibility';

const routes = {
  comparator: '/availibility-dates'
};
export type AvailibilityItem = { startDate: moment.Moment, endDate: moment.Moment, nights: number, price: { currency: string, amount: number } }
export type ListDates = Array<AvailibilityItem>
@Injectable({
  providedIn: 'root'
})
export class AvailibilityDatesService {

  constructor(private apiService: ApiService) {
  }
  getDates(start: string, end: string, adults: number, enfants: number, agesEnfants: Array<any>, currency: string): Observable<any> {

    let params = new HttpParams({
      fromObject: {
        adults: adults.toString(),
        enfants: enfants.toString(),
        curency: currency,
        start: start,
        end: end,
      }
    });
    agesEnfants.forEach(v => {
      params = params.append('agesEnfants[]', v);
    });
    return this.apiService.get(routes.comparator, params)
      .pipe(map((response: any) => {
        if (!!response && isArray(response)) {
          const listDates: ListDates = [];
          response.forEach(v => {
            const startDate = moment(v.startDate);
            const endDate = moment(v.endDate);
            listDates.push({
              ...v,
              startDate: startDate,
              endDate: endDate,
            });
          });
          return listDates;
        }
        return [];
      }));
  }
}
